import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef
} from '@angular/core';
import {
  NgxQrcodeElementTypes,
  NgxQrcodeErrorCorrectionLevels
} from '@techiediaries/ngx-qrcode';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UnitDetailsComponent } from '../unit-details/unit-details.component';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-qr-invtation',
  templateUrl: './qr-invtation.component.html',
  styleUrls: ['./qr-invtation.component.css']
})
export class QrInvtationComponent implements OnInit {
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value = '';
  clientName = '';
  clientInviter = '';
  date = '';
  unitname = '';
  constructor(
    dialogRef: MatDialogRef<UnitDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.clientName = this.data.data.customer_name;
    this.date = this.data.data.valid_from;
    this.clientInviter = this.data.inviter;
    this.unitname = this.data.unitName;
    this.value = this.data.qrName;
  }

  @ViewChild('screen') screen: ElementRef | any;
  @ViewChild('canvas') canvas: ElementRef | any;
  @ViewChild('downloadLink') downloadLink: ElementRef | any;
  dowenload() {
    html2canvas(this.screen.nativeElement).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
      this.downloadLink.nativeElement.download = 'invtation.png';
      this.downloadLink.nativeElement.click();
    });

    // const el: any = document.querySelector('#capture');
    // html2canvas(el).then((canvas: HTMLCanvasElement) => {
    //   document.body.appendChild(canvas);
    // });
  }
}
